import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.VISITOR_MANAGEMENT],
  data() {
    return {
      logo: getPlanLogo(planTypes.VISITOR_MANAGEMENT),
      title: this.$t('billing.visitor_management.title'),
      planType: planTypes.VISITOR_MANAGEMENT,
    };
  },
};
